import { render, staticRenderFns } from "./WizardStepEvaluation.vue?vue&type=template&id=8bcc8dca&scoped=true&"
import script from "./WizardStepEvaluation.vue?vue&type=script&lang=js&"
export * from "./WizardStepEvaluation.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8bcc8dca",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VAlert } from 'vuetify/lib/components/VAlert';
installComponents(component, {VAlert})
